import PropTypes from "prop-types"
import Container from "components/ui/Container"
import Divider from "components/ui/Divider"

function DividerSection({ className }) {
  return (
    <Container className={className}>
      <Divider />
    </Container>
  )
}

DividerSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default DividerSection
